import { memo, PropsWithChildren } from 'react';
import { Modal, ModalBody, ModalContent, ModalHeader } from '@heroui/react';
import { useBodyOverflow } from '@/shared/lib/components/FloatingProvider';
import { scaleInOut } from '@/shared/lib/utils/modalTransitions';

interface FilterModalProps extends PropsWithChildren {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
}

export const FilterModal = memo(({ isOpen, onOpenChange, children }: FilterModalProps) => {
  useBodyOverflow({ elementId: 'filter-modal', condition: isOpen, unlockOnUnmount: true });

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      placement="center"
      backdrop="opaque"
      size="5xl"
      motionProps={scaleInOut}
      shouldBlockScroll={false}
      classNames={{
        base: 'p-6 gap-4 [&_[data-focus-visible=true]]:!outline-none [&_*:focus-visible]:!outline-none',
        closeButton: 'absolute top-[18px] right-4 [&_svg]:w-6 [&_svg]:h-6',
      }}
    >
      <ModalContent>
        {() => (
          <>
            <ModalHeader className="text-lg font-medium text-[#909090] p-0">Filters</ModalHeader>
            <ModalBody className="p-0">{children}</ModalBody>
          </>
        )}
      </ModalContent>
    </Modal>
  );
});
